import React, { useEffect, useMemo, useState, useCallback } from 'react';
import {
  Package,
  Calendar,
  Bell,
  AlarmClock,
  ClipboardList,
  CheckCircle,
  Cake,
  Users,
  Boxes,
  Calculator,
  ShieldCheck,
  Truck,
  Shield,
  MonitorSmartphone,
  ChevronRight,
  Sparkles,
  ShoppingCart,
} from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import RecursosHumanosPanel from './modules/RecursosHumanosPanel';
import AdministracionTIPanel from './modules/AdministracionTIPanel';
import AlmacenPanel from './modules/AlmacenPanel';
import ContabilidadPanel from './modules/ContabilidadPanel';
import ControlOperativoPanel from './modules/ControlOperativoPanel';
import TransportesPanel from './modules/TransportesPanel';
import SeguridadPanel from './modules/SeguridadPanel';
import SGIPanel from './modules/SGIPanel';
import { useWarehouse } from '../Components/useWarehouse/useWarehouse';
import { MaterialsModule } from '../Components/warehouse/MaterialsModule';
import PurchaseOrdersDeliveryModule from '../Components/warehouse/PurchaseOrdersDeliveryModule';
// import { PeopleModule } from '../Components/warehouse/PeopleModule';
import { EntryModule } from '../Components/warehouse/EntryModule';
import { AssignmentModule } from '../Components/AssignmentModule/AssignmentModule';
import { ReturnModule } from '../Components/ReturnModule/ReturnModule';
import { ExitModule } from '../Components/warehouse/ExitModule';
import { ConsumiblesModule } from '../Components/warehouse/ConsumiblesModule';
import { CostCenterReportModule } from '../Components/warehouse/CostCenterReportModule';
import { SubWarehouseConsumptionModule } from '../Components/warehouse/SubWarehouseConsumptionModule';
import { TransferModule } from '../Components/warehouse/TransferModule';
import { MovementsModule } from '../Components/warehouse/MovementsModule';
import { StockModule } from '../Components/warehouse/StockModule';
import { BrandItemModule } from '../Components/warehouse/BrandItemModule';
import { ResponsibleQueryModule } from '../Components/warehouse/ResponsibleQueryModule';
import { SerialQueryModule } from '../Components/warehouse/SerialQueryModule';
import { PendingOrdersModule } from '../Components/warehouse/PendingOrdersModule';
import senerfiBlanco from '../assets/images/senerfiblanco.png';
import senerfitoWsp from '../assets/images/senerfito-wsp.png';
import bienvenidosImage from '../assets/images/Bienvenidos.png';
import soporteSenerfitoGif from '../assets/images/soportesenerfito.gif';
import fondoCumple from '../assets/images/fondo cumple.svg';
import { useUserPrefs } from '../Components/context/UserPrefs';
import MisPendientesWidget from './modules/MisPendientesWidget';
import { api, setCurrentPageContext } from '../services/api';
import { Modal } from '../Components/Modal/Modal';
import ComunicadosWidget from '../Components/ComunicadosWidget/ComunicadosWidget';
import { HelpDeskModal } from '../Components/HelpDesk/HelpDeskModal';
import { createTicketSnapshotDataUrl } from '../Components/HelpDesk/ticketSnapshot';
import SectionIndexCards from '../Components/Common/SectionIndexCards';

// Cuentas autorizadas para aprobar activaciones de 2FA de otros usuarios.
// No se usa el rol "Administrador" porque ese rol se otorga a muchas cuentas
// solo para darles acceso a módulos (almacén, contabilidad, HSE, etc.), sin
// que deban tener la capacidad de aprobar el segundo factor de otras cuentas.
const TOTP_APPROVER_EMAILS = ['admin@senerfi.com', 'soporteti@senerfi.com', 'joluguma22@gmail.com'];

function BirthdayWidget({ people, compact = false, onClose }) {
  const parseBirthDate = (value) => {
    if (!value) return null;
    let d = new Date(value);
    if (!isNaN(d)) return d;
    const m1 = String(value).match(/^(\d{1,2})[-/]?(\d{1,2})[-/]?(\d{2,4})$/);
    if (m1) {
      const day = parseInt(m1[1], 10);
      const month = parseInt(m1[2], 10) - 1;
      const year = parseInt(m1[3], 10);
      d = new Date(year, month, day);
      if (!isNaN(d)) return d;
    }
    const m2 = String(value).toLowerCase().match(/^(\d{1,2})\s+de\s+([a-zñ]+)(?:\s+de\s+(\d{2,4}))?$/i);
    if (m2) {
      const months = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
      const day = parseInt(m2[1], 10);
      const monthIdx = months.indexOf(m2[2]);
      const year = m2[3] ? parseInt(m2[3], 10) : new Date().getFullYear();
      if (monthIdx >= 0) {
        d = new Date(year, monthIdx, day);
        if (!isNaN(d)) return d;
      }
    }
    return null;
  };
  const isBirthdayToday = (value) => {
    const d = parseBirthDate(value);
    if (!d) return false;
    const now = new Date();
    return d.getDate() === now.getDate() && d.getMonth() === now.getMonth();
  };
  const daysUntilBirthday = (value) => {
    const d = parseBirthDate(value);
    if (!d) return null;
    const now = new Date();
    let next = new Date(now.getFullYear(), d.getMonth(), d.getDate());
    if (next < new Date(now.getFullYear(), now.getMonth(), now.getDate())) {
      next = new Date(now.getFullYear() + 1, d.getMonth(), d.getDate());
    }
    const MS = 24 * 60 * 60 * 1000;
    return Math.ceil((next - now) / MS);
  };
  const todayList = (Array.isArray(people) ? people.filter(p => isBirthdayToday(p.birthDate || p.birth_date)) : []).map(p => ({
    name: p.name || '—',
    photo: p.photo || p.photo_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(p.name || 'User')}`,
    daysLeft: 0,
  }));
  const upcomingList = (Array.isArray(people) ? people.map(p => ({ p, days: daysUntilBirthday(p.birthDate || p.birth_date) })) : [])
    .filter(x => typeof x.days === 'number' && x.days >= 1 && x.days <= 7)
    .sort((a, b) => a.days - b.days)
    .map(({ p, days }) => ({
      name: p.name || '—',
      photo: p.photo || p.photo_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(p.name || 'User')}`,
      daysLeft: days,
    }));
  const displayList = todayList.length > 0 ? todayList : (upcomingList.length > 0 ? upcomingList : [{ name: '—', photo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Senerfi', daysLeft: null, placeholder: true }]);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (displayList.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % displayList.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [displayList.length]);
  const hasItems = Array.isArray(displayList) && displayList.length > 0;
  const currentPerson = hasItems ? displayList[currentIndex] : null;
  const isPlaceholder = !!(currentPerson && currentPerson.placeholder);
  const fullTitle = '¡Feliz Cumpleaños!';
  const typedTitle = fullTitle;
  const boxHeight = compact ? '550px' : '50vh';
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-[500px] border-4 relative overflow-hidden flex flex-col" style={{ borderColor: '#F07E2D', height: boxHeight }}>
      {typeof onClose === 'function' && (
        <button
          onClick={onClose}
          className="absolute top-1 right-1 rounded-full w-8 h-8 flex items-center justify-center z-10"
          style={{ backgroundColor: '#FFF', border: '2px solid #F07E2D', color: '#776F74' }}
          aria-label="Cerrar"
        >
          ✕
        </button>
      )}
      <img
        src={fondoCumple}
        alt="Fondo cumpleaños"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ opacity: 0.22, pointerEvents: 'none', zIndex: 0 }}
      />
      <div className="flex items-center justify-center mt-8 mb-4">
        <Cake size={28} className="mr-2" style={{ color: '#F07E2D' }} />
        <h3 className="text-2xl animate-fade-in" style={{ color: '#F07E2D', fontFamily: 'Pacifico, cursive' }}>{typedTitle}</h3>
      </div>
      
      <div className="flex-1 flex items-center justify-center">
        {hasItems ? (
          <div className="relative w-40 h-40 rounded-full border-2 bg-white flex items-center justify-center" style={{ borderColor: '#F07E2D' }}>
            <img key={currentIndex} src={currentPerson.photo} alt={currentPerson.name} className="w-36 h-36 rounded-full object-contain animate-fade-in" />
            <div className="absolute -top-2 -right-2 text-4xl animate-bounce">🎉</div>
          </div>
        ) : null}
      </div>
      {hasItems && !isPlaceholder && (
        <div className="text-center">
          <p className="text-xl md:text-2xl font-bold text-gray-800 mb-2 animate-fade-in break-words leading-tight px-2">{isPlaceholder ? '—' : currentPerson.name}</p>
          {!isPlaceholder && (
            <p className="text-sm text-gray-700">{currentPerson.daysLeft === 0 ? '¡Hoy es su día especial! 🎂' : `En ${currentPerson.daysLeft} día${currentPerson.daysLeft === 1 ? '' : 's'}`}</p>
          )}
        </div>
      )}
      {hasItems && !isPlaceholder && displayList.length > 1 && (
        <div className="flex justify-center space-x-2 mt-3">
          {displayList.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`transition-all`}
              style={index === currentIndex ? { backgroundColor: '#F07E2D', width: 24, height: 8, borderRadius: 9999 } : { backgroundColor: '#D1D5DB', width: 8, height: 8, borderRadius: 9999 }}
              aria-label={`Ver cumpleañero ${index + 1}`}
            />
          ))}
        </div>
      )}
      {!isPlaceholder && (
        <div className="mt-4 flex justify-center space-x-2 text-2xl">
          <span className="animate-pulse">🎈</span>
          <span className="animate-pulse">🎁</span>
          <span className="animate-pulse">🎊</span>
        </div>
      )}
      {hasItems && isPlaceholder && (
        <div className="mt-auto text-center">
          <p className="text-sm font-bold" style={{ color: '#000' }}>Sin cumpleañeros hoy ni próximos en 7 días</p>
          <div className="mt-2 flex justify-center space-x-2 text-2xl">
            <span className="animate-pulse">🎈</span>
            <span className="animate-pulse">🎁</span>
            <span className="animate-pulse">🎊</span>
          </div>
        </div>
      )}
      {hasItems && !isPlaceholder && displayList.length > 1 && (
        <div className="absolute top-2 right-2 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold" style={{ backgroundColor: '#F07E2D' }}>{displayList.length}</div>
      )}
      <style>
        {`
          @keyframes fade-in {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }
          .animate-fade-in { animation: fade-in 0.5s ease-in-out; }
        `}
      </style>
    </div>
  );
}

export default function Sede() {
  const { location } = useParams();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const initialAlmacenSection = (() => { try { const v = localStorage.getItem('senerfi_ui_almacen_section'); return v || null; } catch (_) { return null; } })();
  const [almacenSection, setAlmacenSection] = useState(initialAlmacenSection);
  const initialAlmacenGroup = (() => { try { const v = localStorage.getItem('senerfi_ui_almacen_group'); return v || null; } catch (_) { return null; } })();
  const [almacenGroup, setAlmacenGroup] = useState(initialAlmacenGroup);
  // Reporta al backend (vía cabecera X-Senerfi-Page en cada petición, ver
  // src/services/api.js) qué sede, módulo y submódulo está viendo el
  // usuario en este momento, para que Administración TI > Auditoría pueda
  // mostrar la ruta real en vez de "Sin ruta reportada". Almacén no tiene
  // un panel propio (su navegación de submódulos vive aquí mismo, en
  // Sede.jsx), así que su submódulo (almacenSection) se agrega aquí; los
  // demás paneles (Recursos Humanos, Contabilidad, Transportes, SGI,
  // Control Operativo, Administración TI) reportan el suyo propio desde
  // su propio componente.
  useEffect(() => {
    const sub = selected === 'almacen' ? (almacenSection || '') : '';
    setCurrentPageContext(`/sede/${location || ''}${selected ? `/${selected}` : ''}${sub ? `/${sub}` : ''}`);
  }, [location, selected, almacenSection]);
  const [showAlerts, setShowAlerts] = useState(false);
  const [alerts, setAlerts] = useState({ total: 0, lowStock: 0, expiring: 0, loading: false, lowStockItems: [], expiringItems: [] });
  const [alertsOpen, setAlertsOpen] = useState(null);
  // Fase 4 del puente Almacén–Compras: material que se pasa a Contabilidad
  // > Solicitudes al hacer clic en "Solicitar compra" desde una alerta de
  // stock bajo, para abrir la solicitud ya con ese ítem cargado.
  const [prefillPurchaseRequest, setPrefillPurchaseRequest] = useState(null);
  const requestPurchaseForLowStock = (item) => {
    const deficit = Math.max(1, (parseInt(item.stockMin) || 0) - (parseInt(item.stockActual) || 0));
    setPrefillPurchaseRequest({
      material_id: item.id,
      material_code: item.code || '',
      material_name: item.name || '',
      unit: item.unitLabel || 'Unidad',
      quantity: deficit,
    });
    setSelected('contabilidad');
  };
  const {
    materials,
    brandItems,
    people,
    movements,
    assignments,
    warehouses,
    addWarehouse,
    updateWarehouse,
    deleteWarehouse,
    addMaterial,
    updateMaterial,
    deleteMaterial,
    addBrandItem,
    updateBrandItem,
    deleteBrandItem,
    addPerson,
    updatePerson,
    deletePerson,
    registerEntry,
    registerAssignment,
    registerReturn,
    registerExit,
    registerTransfer,
    movementsRefreshKey,
  } = useWarehouse();
  const [indMode, setIndMode] = useState('mas');
  const [indTab, setIndTab] = useState('elemPorAlmacen');
  const [indWh, setIndWh] = useState(null);
  const [indMat, setIndMat] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [sortDir, setSortDir] = useState('auto');
  const [whOpen, setWhOpen] = useState(false);
  const [newWhName, setNewWhName] = useState('');
  const [newWhCode, setNewWhCode] = useState('');
  const [whErr, setWhErr] = useState('');
  const [editingWhId, setEditingWhId] = useState('');
  const [editingWhName, setEditingWhName] = useState('');
  const [newWhParentId, setNewWhParentId] = useState('');
  const [newWhPrefix, setNewWhPrefix] = useState('');
  const [showBirthdayModal, setShowBirthdayModal] = useState(false);
  const [helpDeskOpen, setHelpDeskOpen] = useState(false);
  const [helpDeskSubmitting, setHelpDeskSubmitting] = useState(false);
  const [helpDeskForm, setHelpDeskForm] = useState({ name: '', email: '', dni: '', subject: '', category: '', department: '', description: '', priority: 'Media' });
  const normalizeModuleKey = useCallback((mod) => {
    return mod === 'sgi' ? 'sig' : mod;
  }, []);
  useEffect(() => {
    const applyNavNext = () => {
      try {
        const raw = localStorage.getItem('senerfi_ui_nav_next');
        if (!raw) return;
        const nav = JSON.parse(raw);
        if (!nav || typeof nav !== 'object') return;
        if (nav.location && String(nav.location) !== String(location)) return;
        if (nav.module) setSelected(normalizeModuleKey(nav.module));
        if (nav.almacenGroup !== undefined) setAlmacenGroup(nav.almacenGroup);
        if (nav.almacenSection !== undefined) setAlmacenSection(nav.almacenSection);
        try { localStorage.removeItem('senerfi_ui_nav_next'); } catch (_) {}
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) {}
      } catch (_) {}
    };
    applyNavNext();
    try { window.addEventListener('senerfi:nav_next', applyNavNext); } catch (_) {}
    return () => { try { window.removeEventListener('senerfi:nav_next', applyNavNext); } catch (_) {} };
  }, [location, normalizeModuleKey]);
  useEffect(() => { if (!indWh && Array.isArray(warehouses) && warehouses.length) setIndWh(warehouses[0].id); }, [indWh, warehouses]);
  useEffect(() => { if (!indMat && Array.isArray(materials) && materials.length) setIndMat(materials[0].id); }, [indMat, materials]);
  useEffect(() => { setSortDir((indMode === 'mas' || indMode === 'prestados') ? 'desc' : 'asc'); }, [indMode]);
  const chartItems = useMemo(() => {
    const normText = (v) => {
      const s = String(v ?? '').toLowerCase().trim();
      return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };
    const normWh = (v) => {
      const s = normText(v);
      const slug = s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      if (/^popayan/.test(slug)) return 'popayan';
      if (/^santander/.test(slug) || /quilichao/.test(slug)) return 'santander';
      if (/^(c054|lv).*centro/.test(slug)) return 'lv-centro';
      if (/^(c086|lv).*norte/.test(slug) || /emcali.*norte/.test(slug)) return 'lv-norte';
      if (/emcali/.test(slug)) return 'emcali';
      return slug || s;
    };
    const isConsumibleMove = (m) => {
      const t = normText(m?.type);
      if (t.includes('consumible')) return true;
      const obs = normText(m?.observations ?? m?.notes);
      if (obs.includes('consumible')) return true;
      const matId = m?.materialId;
      const mat = (materials || []).find(x => String(x.id) === String(matId));
      const cat = normText(mat?.category ?? mat?.type);
      return cat.includes('consumible');
    };
    if (indMode === 'prestados' || indMode === 'consumibles') {
      const typeRegex = indMode === 'prestados' ? /pr[eé]stamo/i : /consumible/i;
      const list = Array.isArray(movements)
        ? movements.filter(m => (indMode === 'consumibles' ? isConsumibleMove(m) : typeRegex.test(String(m?.type || ''))))
        : [];
      const filtered = list.filter(m => {
        let ts = Number(m.ts || 0);
        // Fallback: usar m.date si existe para asegurar comparación correcta
        if (m.date) {
          let dStr = m.date;
          // Si es fecha corta YYYY-MM-DD, agregar hora para interpretar como local
          if (typeof dStr === 'string') {
             if (dStr.length === 10 && dStr.includes('-')) {
               dStr += 'T00:00:00';
             } else if (dStr.length > 10 && dStr.includes(' ')) {
               // Reemplazar espacio por T para compatibilidad ISO
               dStr = dStr.replace(' ', 'T');
             }
          }
          const d = new Date(dStr);
          if (!isNaN(d.getTime())) {
            ts = d.getTime();
          }
        }

        if (fromDate) {
          const fts = new Date(fromDate + 'T00:00:00').getTime();
          if (ts && ts < fts) return false;
        }
        if (toDate) {
          const tts = new Date(toDate + 'T23:59:59').getTime();
          if (ts && ts > tts) return false;
        }
        // Filtro por bodega si está seleccionada
        if (indWh && m.warehouseId) {
          const whFilter = normWh(indWh);
          const mWh = normWh(m.warehouseId);
          if (whFilter && mWh && whFilter !== mWh) return false;
        }
        return true;
      });
      const groups = new Map();
      for (const m of filtered) {
        const matId = m.materialId;
        const mat = (materials||[]).find(x => String(x.id) === String(matId));
        const code = (mat?.code || m.materialCode || m.materialName || '—').toString();
        const name = (mat?.name || m.materialName || '—').toString();
        const responsibleName = String(m.responsibleName || 'Sin responsable').trim() || 'Sin responsable';
        const responsibleDoc = String(m.responsibleDoc || '').trim() || '—';
        const key = indMode === 'prestados'
          ? [matId ? String(matId) : code, responsibleDoc, responsibleName].join('|')
          : (matId ? String(matId) : code);
        
        if (!groups.has(key)) {
          groups.set(key, { 
            label: code, 
            name: name, 
            value: 0,
            responsibleName,
            responsibleDoc,
          });
        }
        groups.get(key).value += (parseInt(m.quantity) || 0);
      }
      const out = Array.from(groups.values());
      out.sort((a,b) => (sortDir==='asc' ? a.value - b.value : b.value - a.value));
      return out; 
    }

    const listAll = Array.isArray(movements) ? movements.filter(m => m.type === 'Asignación') : [];
    const list = listAll.filter(m => {
      let ts = Number(m.ts || 0);
      // Fallback: usar m.date si existe
        if (m.date) {
          let dStr = m.date;
          if (typeof dStr === 'string') {
             if (dStr.length === 10 && dStr.includes('-')) {
               dStr += 'T00:00:00';
             } else if (dStr.length > 10 && dStr.includes(' ')) {
               dStr = dStr.replace(' ', 'T');
             }
          }
          const d = new Date(dStr);
          if (!isNaN(d.getTime())) {
            ts = d.getTime();
          }
        }

      if (fromDate) {
        const fts = new Date(fromDate + 'T00:00:00').getTime();
        if (ts && ts < fts) return false;
      }
      if (toDate) {
        const tts = new Date(toDate + 'T23:59:59').getTime();
        if (ts && ts > tts) return false;
      }
      return true;
    });
    if (indTab === 'elemPorAlmacen') {
      const wh = indWh || (Array.isArray(warehouses) && warehouses[0] ? warehouses[0].id : null);
      const rows = list.filter(a => String(a.warehouseId || '') === String(wh));
      const byMat = new Map();
      for (const a of rows) {
        const k = String(a.materialId || a.materialName || '—');
        const mat = (materials||[]).find(m => Number(m.id) === Number(a.materialId));
        const code = (mat?.code || a.materialCode || a.materialName || '—').toString();
        const name = (mat?.name || a.materialName || '—').toString();
        byMat.set(k, { label: code, name, value: (byMat.get(k)?.value || 0) + (parseInt(a.quantity) || 0) });
      }
      const out = Array.from(byMat.values());
      out.sort((a,b) => (sortDir==='asc' ? a.value - b.value : b.value - a.value));
      return out.slice(0, 10);
    } else {
      const mid = indMat || (Array.isArray(materials) && materials[0] ? materials[0].id : null);
      const rows = list.filter(a => Number(a.materialId) === Number(mid));
      const byWh = new Map();
      for (const a of rows) {
        const k = String(a.warehouseId || '');
        const whObj = (warehouses||[]).find(w => String(w.id)===k);
        const code = whObj?.id || k || '—';
        const name = whObj?.name || code;
        byWh.set(k, { label: code, name, value: (byWh.get(k)?.value || 0) + (parseInt(a.quantity) || 0) });
      }
      const out = Array.from(byWh.values());
      out.sort((a,b) => (sortDir==='asc' ? a.value - b.value : b.value - a.value));
      return out.slice(0, 10);
    }
  }, [movements, indTab, indWh, indMat, indMode, warehouses, materials, fromDate, toDate, sortDir]);
  const maxValue = useMemo(() => {
    return chartItems.reduce((m, it) => Math.max(m, it.value || 0), 0) || 1;
  }, [chartItems]);
  // Eliminado: mapeo y visualizaciÃƒÂ³n de "Sede seleccionada"

  const { currentUser, getModulePrefs } = useUserPrefs();
  const modulePrefs = getModulePrefs(currentUser?.id);
  // Fallback: si no hay permisos cargados, mostrar módulos básicos para evitar que el panel quede vacío
  const fallbackAllowed = useMemo(() => ({
    'recursos-humanos': true,
    'almacen': true,
    'sgi': true,
    'contabilidad': true,
    'control-operativo': true,
    'transportes': true,
    'administracion-ti': true,
  }), []);
  const isAllowed = useCallback((mod) => {
    const prefs = modulePrefs || {};
    const hasAny = Object.keys(prefs || {}).some((k) => !!prefs[k]);
    const ref = hasAny ? prefs : fallbackAllowed;
    return !!ref[mod];
  }, [modulePrefs, fallbackAllowed]);
  const isAllowedModule = useCallback((mod) => {
    if (mod === 'sig') return isAllowed('sig') || isAllowed('sgi');
    return isAllowed(mod);
  }, [isAllowed]);

  const dashboardOnly = !selected;

  const moduleNavItems = useMemo(() => ([
    {
      key: 'recursos-humanos',
      label: 'Recursos Humanos',
      description: 'Colaboradores y novedades',
      icon: Users,
      enabled: isAllowed('recursos-humanos'),
      badge: 'Gestión',
      accent: '#2563EB',
      soft: 'rgba(37, 99, 235, 0.12)',
      softStrong: 'rgba(37, 99, 235, 0.2)',
      iconGradient: 'linear-gradient(135deg, #2563EB 0%, #4F46E5 100%)',
    },
    {
      key: 'almacen',
      label: 'Almacen',
      description: 'Inventario y movimientos',
      icon: Boxes,
      enabled: isAllowed('almacen'),
      badge: 'Operación',
      accent: '#0F766E',
      soft: 'rgba(15, 118, 110, 0.12)',
      softStrong: 'rgba(20, 184, 166, 0.22)',
      iconGradient: 'linear-gradient(135deg, #0F766E 0%, #14B8A6 100%)',
    },
    {
      key: 'sig',
      label: 'SIG',
      description: 'Formularios e indicadores',
      icon: ShieldCheck,
      enabled: isAllowedModule('sig'),
      highlight: true,
      badge: 'Central',
      accent: '#EA580C',
      soft: 'rgba(234, 88, 12, 0.12)',
      softStrong: 'rgba(249, 115, 22, 0.24)',
      iconGradient: 'linear-gradient(135deg, #EA580C 0%, #F59E0B 100%)',
    },
    {
      key: 'contabilidad',
      label: 'Contabilidad',
      description: 'Solicitudes y compras',
      icon: Calculator,
      enabled: isAllowed('contabilidad'),
      badge: 'Finanzas',
      accent: '#7C3AED',
      soft: 'rgba(124, 58, 237, 0.12)',
      softStrong: 'rgba(139, 92, 246, 0.24)',
      iconGradient: 'linear-gradient(135deg, #7C3AED 0%, #A855F7 100%)',
    },
    {
      key: 'control-operativo',
      label: 'Control Operativo',
      description: 'Línea viva y proyectos',
      icon: ClipboardList,
      enabled: isAllowed('control-operativo'),
      badge: 'Control',
      accent: '#DC2626',
      soft: 'rgba(220, 38, 38, 0.12)',
      softStrong: 'rgba(248, 113, 113, 0.22)',
      iconGradient: 'linear-gradient(135deg, #DC2626 0%, #F97316 100%)',
    },
    {
      key: 'transportes',
      label: 'Transportes',
      description: 'Flota y PESV',
      icon: Truck,
      enabled: isAllowed('transportes'),
      badge: 'Flota',
      accent: '#0284C7',
      soft: 'rgba(2, 132, 199, 0.12)',
      softStrong: 'rgba(56, 189, 248, 0.22)',
      iconGradient: 'linear-gradient(135deg, #0284C7 0%, #38BDF8 100%)',
    },
    {
      key: 'seguridad',
      label: 'Seguridad',
      description: 'Visitantes y control',
      icon: Shield,
      enabled: isAllowed('seguridad'),
      badge: 'Protección',
      accent: '#16A34A',
      soft: 'rgba(22, 163, 74, 0.12)',
      softStrong: 'rgba(74, 222, 128, 0.22)',
      iconGradient: 'linear-gradient(135deg, #16A34A 0%, #22C55E 100%)',
    },
    {
      key: 'administracion-ti',
      label: 'Administración TI',
      description: 'Soporte y activos',
      icon: MonitorSmartphone,
      enabled: isAllowed('administracion-ti'),
      badge: 'Soporte',
      accent: '#4F46E5',
      soft: 'rgba(79, 70, 229, 0.12)',
      softStrong: 'rgba(129, 140, 248, 0.22)',
      iconGradient: 'linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)',
    },
  ]).filter((item) => item.enabled), [isAllowed, isAllowedModule]);

  useEffect(() => {
    if (currentUser && !sessionStorage.getItem('senerfi_birthday_shown')) {
      setShowBirthdayModal(true);
      try { sessionStorage.setItem('senerfi_birthday_shown', '1'); } catch (_) {}
    }
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser) return;
    setHelpDeskForm((p) => ({
      ...p,
      name: p.name || (currentUser?.name || ''),
      email: p.email || (currentUser?.email || ''),
    }));
  }, [currentUser]);

  useEffect(() => {
    const handler = () => setHelpDeskOpen(true);
    try { window.addEventListener('senerfi_helpdesk_open', handler); } catch (_) {}
    return () => { try { window.removeEventListener('senerfi_helpdesk_open', handler); } catch (_) {} };
  }, []);

  const formatTicketCode = useCallback((id) => {
    const n = Number(id);
    if (!Number.isFinite(n) || n <= 0) return 'TK-000';
    return `TK-${String(n).padStart(3, '0')}`;
  }, []);

  const submitHelpDesk = useCallback(async () => {
    const payload = {
      name: String(helpDeskForm.name || '').trim(),
      email: String(helpDeskForm.email || '').trim(),
      dni: String(helpDeskForm.dni || '').trim(),
      subject: String(helpDeskForm.subject || '').trim(),
      category: String(helpDeskForm.category || '').trim(),
      department: String(helpDeskForm.department || '').trim(),
      description: String(helpDeskForm.description || '').trim(),
      priority: String(helpDeskForm.priority || 'Media').trim(),
    };
    if (!payload.name || !payload.email || !payload.dni || !payload.subject || !payload.category || !payload.description) {
      alert('Por favor complete los campos obligatorios: Nombre, Correo, Cédula, Título, Categoría y Descripción.');
      return;
    }
    setHelpDeskSubmitting(true);
    try {
      const createdAtLabel = new Date().toLocaleString('es-CO');
      const desc = [
        payload.department ? `Área/Departamento: ${payload.department}` : null,
        payload.description,
      ].filter(Boolean).join('\n\n');
      const res = await api.admin.supports.upsert({
        subject: payload.subject,
        description: desc,
        category: payload.category,
        department: payload.department || null,
        priority: payload.priority,
        requester_name: payload.name,
        requester_dni: payload.dni,
        requester_email: payload.email,
        status: 'Abierto',
      });
      if (!res?.ok) throw new Error(res?.error || 'No fue posible crear el ticket');
      const ticketId = res?.id;
      const ticketCode = formatTicketCode(ticketId);

      try {
        localStorage.setItem('senerfi_ui_admin_ti_view', 'soportes');
        localStorage.setItem('senerfi_ui_admin_ti_group', 'gestion');
      } catch (_) {}

      setSelected('administracion-ti');

      try {
        const dataUrl = createTicketSnapshotDataUrl({
          ticketCode,
          subject: payload.subject,
          status: 'Abierto',
          priority: payload.priority,
          category: payload.category,
          requesterName: payload.name,
          requesterDni: payload.dni,
          requesterEmail: payload.email,
          createdAt: createdAtLabel,
          department: payload.department,
        });
        if (dataUrl) {
          await api.admin.supports.snapshot({ ticket_id: ticketId, image_data: dataUrl });
        }
      } catch (_) {}

      try {
        await api.admin.supports.notify({ ticket_id: ticketId });
      } catch (e) {
        throw new Error(e?.message || 'No fue posible enviar el correo');
      }

      setHelpDeskOpen(false);
      alert(`Ticket creado: ${ticketCode}\nSe envió una copia al correo: ${payload.email}`);
      setHelpDeskForm((p) => ({ ...p, subject: '', category: '', department: '', description: '', priority: 'Media' }));
    } catch (e) {
      alert(e?.message || 'Error enviando el ticket.');
    } finally {
      setHelpDeskSubmitting(false);
    }
  }, [helpDeskForm, formatTicketCode]);

  // No persistimos el módulo seleccionado para que al ingresar siempre se muestre Bienvenidos
  useEffect(() => { try { localStorage.setItem('senerfi_ui_almacen_section', almacenSection || ''); } catch (_) {} }, [almacenSection]);
  useEffect(() => { try { localStorage.setItem('senerfi_ui_almacen_group', almacenGroup || ''); } catch (_) {} }, [almacenGroup]);

  useEffect(() => {
    if (selected && !isAllowedModule(selected)) {
      setSelected(null);
    }
  }, [selected, isAllowedModule]);

  // Seleccionar automáticamente Recursos Humanos al cargar si está permitido
  useEffect(() => {}, [selected, isAllowed]);

  // Navegación manual: no forzar apertura/cierre por sección
  // (Se mantiene la selección manual del usuario en almacenGroup)

  // No establecer sección por defecto al entrar a Almacén para evitar forzar 'Reportes'

  useEffect(() => {
    if (selected !== 'almacen' && showAlerts) setShowAlerts(false);
  }, [selected, showAlerts]);

  const lowStockList = useMemo(() => {
    const list = Array.isArray(materials) ? materials : [];
    return list.filter((m) => {
      const min = parseInt(m.stockMin || 0) || 0;
      const act = parseInt(m.stockActual || 0) || 0;
      return min > 0 && act <= min;
    }).map((m) => ({
      id: m.id,
      code: m.code || '',
      name: m.name || m.materialName || m.descripcion || 'Material',
      stockActual: parseInt(m.stockActual || 0) || 0,
      stockMin: parseInt(m.stockMin || 0) || 0,
      warehouseId: m.warehouseId || m.bodega || '',
      category: m.category || m.categoria || m.type || m.tipo || '',
      unitLabel: m.unit || m.unidad || m.measureUnit || 'unidades'
    }));
  }, [materials]);

  useEffect(() => {
    let cancelled = false;
    const calc = async () => {
      if (selected !== 'almacen') {
        setAlerts({ total: 0, lowStock: 0, expiring: 0, loading: false, lowStockItems: [], expiringItems: [] });
        return;
      }
      setAlerts((p) => ({ ...p, loading: true, lowStock: lowStockList.length, lowStockItems: lowStockList }));
      try {
        // Una sola consulta con los seriales que tienen vencimiento. Antes se
        // pedían los seriales de CADA material (~1.600 consultas pesadas por
        // usuario al abrir Almacén) y eso saturó la base de datos el
        // 23-oct-2026; en total hay pocas decenas de seriales con vencimiento.
        let arr = [];
        try {
          const r = await api.serials.list({ action: 'expiring' });
          arr = Array.isArray(r?.data) ? r.data : [];
        } catch (_) {}
        const matsList = Array.isArray(materials) ? materials : [];
        const codesInArr = Array.from(new Set((arr || []).map(s => String(s.material_code || s.materialCode || '').trim()).filter(Boolean)));
        const missingCodes = codesInArr.filter(code => !matsList.some(m => String(m.code || '') === code));
        const extraByCode = {};
        for (const code of missingCodes) {
          try {
            const resp = await api.materials.get({ code });
            const m = resp?.data;
            if (m) extraByCode[code] = m;
          } catch (_) {}
        }
        const soonItems = arr.filter((s) => {
          const raw = s.warranty_until || s.vencimiento || s.expire_at || s.expiration_date;
          if (!raw) return false;
          // Si el registro indica explícitamente que NO requiere vencimiento, ignorar
          if (s.requires_expire === 0 || String(s.requires_expire).toLowerCase() === 'false') return false;
          const d = new Date(raw);
          if (isNaN(d)) return false;
          const now = new Date();
          const diff = (d.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
          return diff <= 30;
        }).map((s) => {
          const expireAt = s.warranty_until || s.vencimiento || s.expire_at || s.expiration_date;
          const nmRaw = s.materialName || s.material_name || s.name || '';
          const mid = s.materialId || s.itemId || '';
          const mcodeRaw = s.material_code || s.materialCode || '';
          const mat = matsList.find((m) => String(m.id || '') === String(mid || ''))
            || matsList.find((m) => String(m.code || '') === String(mcodeRaw || ''))
            || matsList.find((m) => String(m.name || m.materialName || '').trim().toLowerCase() === String(nmRaw || '').trim().toLowerCase());
          const matFallback = (!mat && mcodeRaw) ? extraByCode[mcodeRaw] : null;
          const serialRaw = s.serial || s.code || s.serial_code || s.serie || s.brand_serial || '';
          return {
            id: s.id || s.serial || s.code,
            serial: serialRaw,
            materialName: (nmRaw || mat?.name || mat?.materialName || matFallback?.name || ''),
            materialCode: (mat?.code || mcodeRaw || matFallback?.code || ''),
            expireAt,
            stockActual: parseInt(mat?.stockActual || 0) || 0,
            category: mat?.category || mat?.categoria || mat?.type || mat?.tipo || '',
            unitLabel: mat?.unit || mat?.unidad || mat?.measureUnit || 'unidades',
          };
        });
        const soon = soonItems.length;
        if (!cancelled) setAlerts({ total: lowStockList.length + soon, lowStock: lowStockList.length, expiring: soon, loading: false, lowStockItems: lowStockList, expiringItems: soonItems });
      } catch (_) {
        if (!cancelled) setAlerts({ total: lowStockList.length, lowStock: lowStockList.length, expiring: 0, loading: false, lowStockItems: lowStockList, expiringItems: [] });
      }
    };
    calc();
    return () => { cancelled = true; };
  }, [selected, lowStockList, materials]);

  const handleBrandClick = () => {
    // Cerrar todas las secciones del contenedor sin ir al login
    setSelected(null);
    setAlmacenSection(null);
    setAlmacenGroup(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Recuadro superior con info del responsable asignado al usuario actual
  const [responsibleInfo, setResponsibleInfo] = useState({ loading: false, person: null, error: '' });
  const responsibleCedula = useMemo(() => (currentUser?.responsibleCedula || currentUser?.responsible_cedula || '').trim(), [currentUser]);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const ced = responsibleCedula;
      if (!ced) {
        setResponsibleInfo({ loading: false, person: null, error: '' });
        return;
      }
      setResponsibleInfo((s) => ({ ...s, loading: true, error: '' }));
      try {
        // Combinar perfil RRHH (foto, datos personales) con empleado (cargo/área) y datos de people (foto/adjunto)
        const [resProf, resEmp, resPeople] = await Promise.all([
          api.hr.profiles.get({ dni: ced }),
          api.hr.employees.get({ dni: ced }),
          api.people.get({ dni: ced, clean: 1 })
        ]);
        const profile = resProf?.data || null;
        const employee = resEmp?.data || null;
        const pData = (() => {
          const d = resPeople?.data;
          if (!d) return null;
          if (Array.isArray(d)) return d[0] || null;
          return d;
        })();

        // Elegir mejor fuente de foto disponible
        const pickPhoto = () => {
          const candidates = [
            profile?.photo_url,
            profile?.photo,
            profile?.foto,
            pData?.photo,
            pData?.foto,
            pData?.adjuntos, // primer adjunto como fallback si es imagen
            employee?.photo_url,
          ].filter(Boolean);
          const first = candidates.find((u) => {
            const s = String(u || '');
            const ext = s.split('?')[0].split('#')[0].toLowerCase();
            return ext.endsWith('.png') || ext.endsWith('.jpg') || ext.endsWith('.jpeg') || /^https?:\/\//.test(s);
          });
          return first || '';
        };

        const resolvedName = (
          profile?.name
          ?? profile?.full_name
          ?? profile?.nombre
          ?? profile?.nombre_completo
          ?? employee?.name
          ?? employee?.full_name
          ?? employee?.nombre
          ?? employee?.nombre_completo
          ?? pData?.name
          ?? pData?.full_name
          ?? pData?.nombre
          ?? pData?.nombre_completo
          ?? ''
        );
        let movementPerson = null;
        if (!resolvedName) {
          try {
            const mvResp = await api.movements.get({ requester_query: ced, order: 'desc', limit: 1 });
            const mvRow = Array.isArray(mvResp?.data) ? mvResp.data[0] : (mvResp?.data || null);
            const pid = mvRow?.requester_id;
            if (pid) {
              const pRes = await api.people.get({ id: pid, clean: 1 });
              const p = (() => {
                const d = pRes?.data;
                if (!d) return null;
                if (Array.isArray(d)) return d[0] || null;
                return d;
              })();
              if (p) movementPerson = p;
            }
          } catch (_) {}
        }
        let fallbackUser = null;
        if (!resolvedName && !movementPerson?.name && !movementPerson?.nombre_completo) {
          try {
            const raw = localStorage.getItem('senerfi_user_prefs');
            const prefs = raw ? JSON.parse(raw) : {};
            const users = Array.isArray(prefs?.users) ? prefs.users : [];
            const u = users.find((x) => {
              const rid = String(ced).trim();
              return String(x?.responsibleCedula || x?.responsible_cedula || x?.cedula || x?.dni || x?.doc || '').trim() === rid;
            });
            if (u) fallbackUser = u;
          } catch (_) {}
        }
        const person = (profile || employee || pData || movementPerson) ? {
          ...(employee || {}),
          ...(profile || {}),
          ...(pData || {}),
          ...(movementPerson || {}),
          // Normalizar algunos campos esperados
          name: resolvedName || (movementPerson?.name || movementPerson?.nombre_completo || movementPerson?.nombre || '') || (fallbackUser?.name || fallbackUser?.nombre || ''),
          position: (employee?.position ?? profile?.position ?? profile?.role ?? pData?.position ?? ''),
          department: (employee?.department ?? profile?.department ?? profile?.area ?? pData?.department ?? pData?.area ?? ''),
          photo_url: pickPhoto(),
        } : (fallbackUser ? {
          name: fallbackUser?.name || fallbackUser?.nombre || '',
          position: fallbackUser?.role || 'Usuario',
          department: '',
          photo_url: '',
        } : null);
        if (!cancelled) setResponsibleInfo({ loading: false, person, error: '' });
      } catch (e) {
        if (!cancelled) setResponsibleInfo({ loading: false, person: null, error: e?.message || 'Error cargando responsable' });
      }
    };
    load();
    return () => { cancelled = true; };
  }, [responsibleCedula]);

  const ResponsibleBox = ({ showAlerts, setShowAlerts, isAlmacen }) => {
    const { loading, person } = responsibleInfo;
    const ced = responsibleCedula;
    const displayName = person?.name || person?.full_name || person?.nombre || person?.nombre_completo || '';
    // Resolver URL absoluta para rutas relativas bajo /api
        const resolveApiUrl = (rel) => {
      if (!rel) return '';
      try {
        const origin = (typeof window !== 'undefined' ? window.location.origin : '');
        const base = (process.env.PUBLIC_URL || '/').replace(/\/$/, '');
        const cleaned = String(rel).replace(/^\/+/, '');
        const withApi = /^api\//i.test(cleaned) ? cleaned : `api/${cleaned}`;
        return `${origin}${base}/${withApi}`;
      } catch (_) {
        return rel;
      }
    };
    const rawPhoto = person?.photo || person?.foto || person?.photo_url || '';
    const photoSrc = /^https?:\/\//i.test(String(rawPhoto)) ? rawPhoto : resolveApiUrl(rawPhoto);
    const initials = useMemo(() => {
      const n = String(displayName || '').trim();
      if (!n) return (String(currentUser?.name || '') || 'U').split(' ').map(p => p[0]).slice(0,2).join('').toUpperCase();
      return n.split(' ').map(p => p[0]).slice(0,2).join('').toUpperCase();
    }, [displayName]);
    return (
      <div className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-lg shadow-sm relative">
        {isAlmacen && (
          <div className="absolute right-2 top-2 z-50" />
        )}
        <div className="flex items-center gap-3">
          {loading ? (
            <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse" aria-hidden="true" />
          ) : photoSrc ? (
            <img src={photoSrc} alt="Foto del responsable" className="w-10 h-10 rounded-full object-cover border border-orange-300" />
          ) : (
            <div className="w-10 h-10 rounded-full bg-orange-200 text-orange-800 flex items-center justify-center font-semibold border border-orange-300" aria-label="Iniciales responsable">
              {initials}
            </div>
          )}
          <div className="flex flex-col">
            <span className="text-sm text-gray-600">Responsable asignado</span>
            {ced ? (
              <>
            <span className="text-base font-semibold text-gray-900">{displayName || 'Sin nombre disponible'} <span className="text-gray-500 font-normal">· Cédula {ced}</span></span>
                {(() => {
                  const pos = person?.position || person?.cargo_rol || person?.role || '';
                  const dept = person?.department || person?.area || '';
                  if (!pos && !dept) return null;
                  return (
                    <span className="text-sm text-gray-700">{pos || '—'}{dept ? <span className="text-gray-400"> · {dept}</span> : null}</span>
                  );
                })()}
              </>
            ) : (
              <span className="text-base font-semibold text-gray-700">Usuario sin responsable asignado</span>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header tipo inicio de pagina con contenedor naranja y logo */}
      <div
        className="w-full shadow-md border-b border-gray-300 flex items-center justify-between px-4"
        style={{
          background: 'linear-gradient(135deg, #776F74 0%, #8D858B 55%, #F07E2D 100%)',
          height: '4.8rem',
        }}
      >
        <div className="flex items-center">
          <img src={senerfiBlanco} alt="Senerfi" className="w-auto cursor-pointer" style={{ height: '5rem' }} onClick={handleBrandClick} />
        </div>
        <div>
          <ComunicadosWidget showOnSessionStart={!!currentUser} pauseStartupAlert={!!showBirthdayModal} />
        </div>
      </div>

      {/* Contenedor principal: inicio compacto y vista lateral cuando hay módulo abierto */}
      <div className="w-full">
        <div className={dashboardOnly
          ? 'mx-auto flex flex-col md:flex-row max-w-[1280px] items-stretch md:items-start gap-3 px-2.5 py-3'
          : 'mx-auto flex flex-col md:flex-row min-h-[calc(100vh-4.8rem)] max-w-[1280px] items-stretch md:items-start gap-2.5 px-2.5 py-3'}
        >
          {/* Panel de opciones (izquierda en pantallas medianas+, arriba en celular) */}
          <div className={dashboardOnly
            ? 'md:sticky md:top-3 w-full md:w-60 md:shrink-0 rounded-[18px] border border-gray-200 bg-white p-1.5 shadow-xl flex flex-col min-h-0'
            : 'md:sticky md:top-3 w-full md:w-60 md:shrink-0 rounded-[18px] border border-gray-200 bg-white p-1.5 shadow-xl flex flex-col md:max-h-[calc(100vh-7.2rem)] min-h-0'}
          >
            <div
              className="relative overflow-hidden rounded-[14px] p-1.5 text-white shadow-md"
              style={{ background: 'linear-gradient(135deg, #776F74 0%, #8D858B 55%, #F07E2D 100%)' }}
            >
              <div className="absolute -right-4 -top-4 h-12 w-12 rounded-full bg-white/10" />
              <div className="absolute -bottom-5 -left-4 h-12 w-12 rounded-full bg-white/10" />
              <div className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full border border-white/35 bg-white/10 shadow-[0_0_18px_rgba(34,197,94,0.28)] backdrop-blur-sm">
                <div className="flex h-5 w-5 items-center justify-center rounded-full bg-emerald-500 text-white shadow-[0_0_10px_rgba(34,197,94,0.65)]">
                  <CheckCircle size={12} strokeWidth={2.6} />
                </div>
              </div>
              <div className="relative">
                <div className="inline-flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wide">
                  <Sparkles size={10} />
                  <span>Panel principal</span>
                </div>
                <h3 className="mt-1 text-[11px] font-bold">Módulos</h3>
                <p className="mt-0.5 text-[8px] leading-3 text-white/90">
                  {dashboardOnly ? 'Selecciona tu acceso.' : 'Accesos rápidos.'}
                </p>
              </div>
            </div>

            <div className={`min-h-0 flex-1 overflow-y-auto pr-0.5 ${dashboardOnly ? 'mt-1.5 space-y-1' : 'mt-2 space-y-1.5'}`}>
              {moduleNavItems.map((item) => {
                const Icon = item.icon;
                const active = selected === item.key;
                const accent = item.accent || '#776F74';
                const iconBackground = active
                  ? item.iconGradient || 'linear-gradient(135deg, #F07E2D 0%, #EA6A16 100%)'
                  : item.highlight
                    ? item.iconGradient || 'linear-gradient(135deg, #F07E2D 0%, #EA6A16 100%)'
                    : `linear-gradient(135deg, ${item.softStrong || 'rgba(119,111,116,0.22)'} 0%, ${item.soft || 'rgba(119,111,116,0.12)'} 100%)`;
                const compactMenu = true;
                const cardBackground = active
                  ? `linear-gradient(135deg, ${item.softStrong || 'rgba(240,126,45,0.18)'} 0%, ${item.soft || 'rgba(240,126,45,0.08)'} 52%, rgba(255,255,255,1) 100%)`
                  : dashboardOnly
                    ? 'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(249,250,251,0.98) 100%)'
                    : 'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)';

                return (
                  <button
                    key={item.key}
                    type="button"
                    title={`${item.label}: ${item.description}`}
                    className={`group relative w-full overflow-hidden border text-left transition-all duration-300 focus:outline-none ${
                      dashboardOnly ? 'rounded-[12px]' : 'rounded-[12px]'
                    } ${
                      active
                        ? 'shadow-md'
                        : dashboardOnly
                          ? 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
                          : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
                    }`}
                    style={{
                      background: cardBackground,
                      borderColor: active ? item.softStrong || '#FED7AA' : undefined,
                      boxShadow: active && dashboardOnly
                        ? `0 10px 24px -18px ${accent}, 0 0 0 1px ${item.softStrong || 'rgba(240,126,45,0.22)'}`
                        : undefined,
                    }}
                    aria-current={active ? 'page' : undefined}
                    onClick={() => setSelected(item.key)}
                  >
                    <div className="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.45) 50%, transparent 100%)', transform: 'translateX(-35%) skewX(-18deg)' }} />
                    <div
                      className="absolute left-0 top-0 bottom-0 w-[3px]"
                      style={{ background: active ? item.iconGradient || `linear-gradient(180deg, ${accent} 0%, ${accent} 100%)` : `linear-gradient(180deg, ${accent} 0%, ${accent} 100%)` }}
                    />
                    {compactMenu ? (
                      <div className="relative flex items-center gap-2.5 px-2 py-2">
                        <div
                          className={`relative flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-white shadow-sm transition-transform duration-300 ${active ? 'scale-[1.03]' : ''}`}
                          style={{ background: iconBackground }}
                        >
                          <div className="absolute inset-1 rounded-[8px] border border-white/15" />
                          <Icon size={16} />
                        </div>
                        <div className="min-w-0 flex-1 pr-0.5">
                          <div className="flex items-center">
                            <div
                              className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[11px] font-semibold leading-none"
                              style={{ color: active ? accent : '#111827' }}
                            >
                              {item.label}
                            </div>
                          </div>
                          <div className="mt-1 flex items-center gap-1.5">
                            <span
                              className={`h-1.5 w-1.5 rounded-full ${active ? 'animate-pulse' : ''}`}
                              style={{ backgroundColor: accent }}
                            />
                            <span
                              className="overflow-hidden text-ellipsis whitespace-nowrap text-[8.5px] font-medium leading-none"
                              style={{ color: active ? accent : '#6B7280' }}
                            >
                              {item.description}
                            </span>
                          </div>
                        </div>
                        <div
                          className="shrink-0 rounded-full p-1 transition-colors group-hover:bg-white/70"
                          style={{
                            backgroundColor: active ? item.softStrong || '#FFEDD5' : '#F8FAFC',
                            color: active ? accent : '#9CA3AF',
                          }}
                        >
                          <ChevronRight size={12} />
                        </div>
                      </div>
                    ) : (
                      <div className="relative flex items-center gap-2 px-2.25 py-1.5">
                        <div
                          className="relative flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-white shadow-sm"
                          style={{ background: iconBackground }}
                        >
                          <div className="absolute inset-1 rounded-[8px] border border-white/15" />
                          <Icon size={14} />
                        </div>
                        <div className="min-w-0 flex-1">
                          <div className="flex items-center gap-1.5">
                            <div className="text-[11px] font-semibold text-gray-900">
                              {item.label}
                            </div>
                            <span
                              className="rounded-full px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wide"
                              style={{ backgroundColor: active ? item.softStrong || '#FFEDD5' : item.soft || '#F3F4F6', color: active ? accent : '#6B7280' }}
                            >
                              {item.badge}
                            </span>
                          </div>
                          <div className="mt-0.5 text-[8.5px] leading-3 text-gray-600">
                            {item.description}
                          </div>
                          <div className="mt-0.5 flex items-center gap-2">
                            <span
                              className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[9px] font-medium ${active ? 'bg-white shadow-sm' : ''}`}
                              style={{ color: active ? accent : '#6B7280', backgroundColor: active ? '#FFFFFF' : item.soft || '#F3F4F6' }}
                            >
                              <span className={`h-1.5 w-1.5 rounded-full ${active ? 'animate-pulse' : ''}`} style={{ backgroundColor: active ? accent : '#9CA3AF' }} />
                              {active ? 'Activo' : 'Listo'}
                            </span>
                          </div>
                        </div>
                        <div
                          className="shrink-0 rounded-full p-1 transition-colors group-hover:bg-white/70"
                          style={{ backgroundColor: active ? item.softStrong || '#FFEDD5' : item.soft || '#F3F4F6', color: active ? accent : '#6B7280' }}
                        >
                          <ChevronRight size={10} />
                        </div>
                      </div>
                    )}
                  </button>
                );
              })}
            </div>

            {dashboardOnly && (
              <div className="mt-1 rounded-2xl border border-orange-100 bg-orange-50/70 px-2 py-1.5 text-center">
                <div className="text-[10px] font-semibold uppercase tracking-wide text-orange-700">Acceso</div>
                <div className="mt-0.5 text-[9px] text-gray-600">Visual, compacto y rapido.</div>
              </div>
            )}

            {/* Boton de cerrar sesion centrado dentro del panel */}
            <div className={`mt-auto ${dashboardOnly ? 'pt-2' : 'pt-2.5'} space-y-1.5`}>
              {TOTP_APPROVER_EMAILS.includes(String(currentUser?.email || '').trim().toLowerCase()) && (
                <button
                  onClick={() => navigate('/aprobaciones-2fa')}
                  className="w-full rounded-xl font-semibold text-gray-700 border border-gray-300 bg-white shadow-sm transition hover:bg-gray-50 focus:outline-none px-2.5 py-1.5 text-[10px]"
                  aria-label="Aprobaciones de doble factor"
                >
                  Aprobaciones 2FA
                </button>
              )}
              <button
                onClick={() => { try { /* No limpiar storage para conservar cambios */ } catch (e) {} navigate('/'); }}
                className={`w-full rounded-xl font-semibold text-white shadow-md transition hover:opacity-90 focus:outline-none ${dashboardOnly ? 'px-2.5 py-1.5 text-[10px]' : 'px-2.5 py-1.5 text-[10px]'}`}
                style={{ backgroundColor: '#04873B' }}
                aria-label="SALIR"
              >
                SALIR
              </button>
            </div>
          </div>

          {dashboardOnly && (
            <>
              <div className="hidden md:block w-px self-stretch bg-gradient-to-b from-transparent via-gray-300 to-transparent" />
              <div className="flex-1 min-w-0 rounded-[20px] border border-gray-200 bg-white p-4 shadow-xl">
                <ResponsibleBox showAlerts={showAlerts} setShowAlerts={setShowAlerts} isAlmacen={false} />
                <MisPendientesWidget onNavigate={(key) => setSelected(key)} onNavigateRoute={(path) => navigate(path)} modulePrefs={modulePrefs} />
                <div className="overflow-hidden rounded-[24px] border border-orange-100 bg-gradient-to-br from-white via-orange-50/60 to-orange-100/70 shadow-inner">
                  <div className="grid min-h-[280px] grid-cols-1 items-stretch gap-0 lg:grid-cols-[0.8fr_1.4fr]">
                    <div className="relative flex items-center justify-center overflow-hidden bg-[radial-gradient(circle_at_top_left,_rgba(240,126,45,0.14),_transparent_48%),linear-gradient(180deg,_rgba(255,255,255,0.96),_rgba(249,250,251,0.92))] p-4">
                      <div className="absolute inset-0 opacity-60" style={{ background: 'linear-gradient(135deg, rgba(240,126,45,0.06) 0%, transparent 45%, rgba(119,111,116,0.07) 100%)' }} />
                      <img
                        src={bienvenidosImage}
                        alt="Bienvenida Senerfi"
                        className="relative z-10 h-[110px] w-full max-w-[180px] object-contain opacity-20"
                      />
                    </div>
                    <div className="relative flex flex-col justify-center overflow-hidden bg-[linear-gradient(135deg,_rgba(119,111,116,0.94)_0%,_rgba(141,133,139,0.88)_36%,_rgba(240,126,45,0.92)_100%)] px-7 py-6 text-white">
                      <div className="absolute -left-16 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full bg-white/10 blur-sm" />
                      <div className="absolute -right-10 top-8 h-32 w-32 rounded-full border border-white/20 bg-white/10" />
                      <div className="relative z-10">
                        <div className="mb-2 inline-flex items-center rounded-full border border-white/20 bg-white/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/90">
                          Inicio Senerfi
                        </div>
                        <div className="text-[clamp(2rem,3.7vw,3.4rem)] font-black leading-none tracking-tight">
                          BIENVENIDOS
                        </div>
                        <div className="mt-2.5 max-w-[26rem] text-[15px] font-medium text-white/90">
                          {currentUser?.name ? `Hola, ${currentUser.name}. Que bueno verte de nuevo en tu panel de trabajo.` : 'Bienvenido al panel principal de trabajo de Senerfi.'}
                        </div>
                        <div className="mt-4 flex items-center gap-3">
                          <div className="rounded-2xl bg-white/12 px-4 py-1.5 text-[12px] font-semibold text-white/90 backdrop-blur-sm">
                            Accesos rapidos y gestion centralizada
                          </div>
                        </div>
                        <img
                          src={senerfiBlanco}
                          alt="Logo Senerfi"
                          className="mt-5 h-9 w-auto opacity-90"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-4 text-center text-[11px] text-gray-500">
                  <div>&copy; 2026 Senerfi SAS</div>
                  <div>Soluciones que generan desarrollo</div>
                </div>
              </div>
            </>
          )}

          {!dashboardOnly && (
            <>
              <div className="w-px bg-gradient-to-b from-transparent via-gray-300 to-transparent" />
              <div className="flex-1 bg-white rounded-[20px] shadow-xl border border-gray-200 p-4 overflow-auto relative min-h-[calc(100vh-7.2rem)]">
                <ResponsibleBox showAlerts={showAlerts} setShowAlerts={setShowAlerts} isAlmacen={selected === 'almacen'} />
            {selected === 'recursos-humanos' && isAllowed('recursos-humanos') && (
              <RecursosHumanosPanel
                location={location}
                showLocation={false}
                people={people}
                onAddPerson={addPerson}
                onUpdatePerson={updatePerson}
                onDeletePerson={deletePerson}
              />
            )}
            {selected === 'almacen' && isAllowed('almacen') && (
              <div className="space-y-8">
                <AlmacenPanel location={location} showLocation={false} />
                <div className="space-y-6">
                  {/* Respaldo/Restauración JSON para Almacén oculto por solicitud */}
                  {/* Índice de secciones para navegación rápida */}
                  <SectionIndexCards
                    title="Indice de secciones"
                    helperText="Organiza configuraciones, movimientos y reportes del almacen con el mismo estilo visual de SIG."
                    columnsClassName="xl:grid-cols-2"
                    items={[
                      {
                        key: 'configuraciones',
                        title: 'Configuraciones',
                        description: 'Marca, materiales y gestion de bodegas',
                        icon: Package,
                        gradient: 'linear-gradient(135deg, #2563EB 0%, #4F46E5 100%)',
                        accentGradient: 'linear-gradient(180deg, #3B82F6 0%, #4F46E5 100%)',
                        active: almacenGroup === 'configuraciones',
                        expanded: almacenGroup === 'configuraciones',
                        onClick: () => setAlmacenGroup(almacenGroup === 'configuraciones' ? null : 'configuraciones'),
                        children: [
                          { key: 'marca-item', label: 'Marca', active: almacenSection === 'marca-item', onClick: () => setAlmacenSection('marca-item') },
                          { key: 'materiales', label: 'Materiales', active: almacenSection === 'materiales', onClick: () => setAlmacenSection('materiales') },
                          { key: 'bodegas', label: 'Bodegas', active: false, onClick: () => setWhOpen(true) },
                        ],
                      },
                      {
                        key: 'movimientos',
                        title: 'Movimientos',
                        description: 'Entradas, salidas, asignaciones y traslados',
                        icon: ClipboardList,
                        gradient: 'linear-gradient(135deg, #0F766E 0%, #14B8A6 100%)',
                        accentGradient: 'linear-gradient(180deg, #14B8A6 0%, #0F766E 100%)',
                        active: almacenGroup === 'movimientos',
                        expanded: almacenGroup === 'movimientos',
                        onClick: () => setAlmacenGroup(almacenGroup === 'movimientos' ? null : 'movimientos'),
                        children: [
                          { key: 'pedidos', label: 'Pedidos pendientes', active: almacenSection === 'pedidos', onClick: () => setAlmacenSection('pedidos') },
                          { key: 'entrada', label: 'Entrada', active: almacenSection === 'entrada', onClick: () => setAlmacenSection('entrada') },
                          { key: 'asignacion', label: 'Asignacion', active: almacenSection === 'asignacion', onClick: () => setAlmacenSection('asignacion') },
                          { key: 'prestamo', label: 'Prestamo', active: almacenSection === 'prestamo', onClick: () => setAlmacenSection('prestamo') },
                          { key: 'devoluciones', label: 'Devolucion', active: almacenSection === 'devoluciones', onClick: () => setAlmacenSection('devoluciones') },
                          { key: 'salidas', label: 'Salida', active: almacenSection === 'salidas', onClick: () => setAlmacenSection('salidas') },
                          { key: 'traslados', label: 'Traslados', active: almacenSection === 'traslados', onClick: () => setAlmacenSection('traslados') },
                          { key: 'consumibles', label: 'Consumibles', active: almacenSection === 'consumibles', onClick: () => setAlmacenSection('consumibles') },
                          { key: 'consumos-subbodega', label: 'Consumos', active: almacenSection === 'consumos-subbodega', onClick: () => setAlmacenSection('consumos-subbodega') },
                        ],
                      },
                      {
                        key: 'reportes',
                        title: 'Reportes',
                        description: 'Consultas, alertas e indicadores del almacen',
                        icon: Bell,
                        gradient: 'linear-gradient(135deg, #EA580C 0%, #F59E0B 100%)',
                        accentGradient: 'linear-gradient(180deg, #F97316 0%, #EA580C 100%)',
                        active: almacenGroup === 'reportes',
                        expanded: almacenGroup === 'reportes',
                        onClick: () => setAlmacenGroup(almacenGroup === 'reportes' ? null : 'reportes'),
                        children: [
                          { key: 'stock', label: 'Existencias', active: almacenSection === 'stock', onClick: () => setAlmacenSection('stock') },
                          { key: 'consulta-responsable', label: 'Consulta por responsable', active: almacenSection === 'consulta-responsable', onClick: () => setAlmacenSection('consulta-responsable') },
                          { key: 'consulta-serial', label: 'Consulta por serial', active: almacenSection === 'consulta-serial', onClick: () => setAlmacenSection('consulta-serial') },
                          { key: 'historial', label: 'Historico', active: almacenSection === 'historial', onClick: () => setAlmacenSection('historial') },
                          { key: 'alertas', label: 'Alertas', active: almacenSection === 'alertas', onClick: () => setAlmacenSection('alertas') },
                          { key: 'indicadores', label: 'Indicadores', active: almacenSection === 'indicadores', onClick: () => setAlmacenSection('indicadores') },
                          { key: 'consumo-centro-costo', label: 'Consumo por área', active: almacenSection === 'consumo-centro-costo', onClick: () => setAlmacenSection('consumo-centro-costo') },
                        ],
                      },
                      {
                        key: 'compras-pendientes',
                        title: 'Pedidos de compra',
                        description: 'Requisiciones aprobadas y OC pendientes por llegar',
                        icon: Truck,
                        gradient: 'linear-gradient(135deg, #7C3AED 0%, #A855F7 100%)',
                        accentGradient: 'linear-gradient(180deg, #A855F7 0%, #7C3AED 100%)',
                        active: almacenSection === 'compras-pendientes',
                        onClick: () => setAlmacenSection('compras-pendientes'),
                      },
                    ]}
                  />

                  {almacenSection === 'materiales' && (
                    <section id="materiales" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <MaterialsModule
                        materials={materials}
                        onAdd={addMaterial}
                        onUpdate={updateMaterial}
                        onDelete={deleteMaterial}
                      />
                    </section>
                  )}

                  {almacenSection === 'pedidos' && (
                    <section id="pedidos" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <PendingOrdersModule
                        location={location}
                        materials={materials}
                        people={people}
                        warehouses={warehouses}
                        onApproveAssign={registerAssignment}
                      />
                    </section>
                  )}

                  {almacenSection === 'compras-pendientes' && (
                    <section id="compras-pendientes" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <PurchaseOrdersDeliveryModule location={location} warehouses={warehouses} />
                    </section>
                  )}

                  {almacenSection === 'stock' && (
                    <section id="stock" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <StockModule
                        materials={materials}
                        warehouses={warehouses}
                        onAdd={addMaterial}
                        onUpdate={updateMaterial}
                        onDelete={deleteMaterial}
                      />
                    </section>
                  )}

                  {almacenSection === 'consulta-responsable' && (
                    <section id="consulta-responsable" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <ResponsibleQueryModule
                        assignments={assignments}
                        materials={materials}
                        people={people}
                        warehouses={warehouses}
                      />
                    </section>
                  )}

                  {almacenSection === 'consulta-serial' && (
                    <section id="consulta-serial" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <SerialQueryModule
                        assignments={assignments}
                        materials={materials}
                        movements={movements}
                        warehouses={warehouses}
                        people={people}
                      />
                    </section>
                  )}


                  {almacenSection === 'marca-item' && (
                    <section id="marca-item" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <BrandItemModule
                        materials={materials}
                        brandItems={brandItems}
                        onAdd={addBrandItem}
                        onUpdate={updateBrandItem}
                        onDelete={deleteBrandItem}
                      />
                    </section>
                  )}


                  {/* Sección Personas oculta en Almacén para que solo se muestre en Recursos Humanos */}

                  {almacenSection === 'entrada' && (
                    <section id="entrada" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <EntryModule
                        materials={materials}
                        brandItems={brandItems}
                        warehouses={warehouses}
                        location={location}
                        onRegister={registerEntry}
                        onAdd={addMaterial}
                      />
                    </section>
                  )}

                  {almacenSection === 'asignacion' && (
                    <section id="asignacion" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <AssignmentModule
                        materials={materials}
                        people={people}
                        assignments={assignments}
                        brandItems={brandItems}
                        movements={movements}
                        warehouses={warehouses}
                        onRegister={registerAssignment}
                        initialType="Asignación"
                      />
                    </section>
                  )}

                  {almacenSection === 'prestamo' && (
                    <section id="prestamo" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <AssignmentModule
                        materials={materials}
                        people={people}
                        assignments={assignments}
                        brandItems={brandItems}
                        movements={movements}
                        warehouses={warehouses}
                        onRegister={registerAssignment}
                        onReturn={registerReturn}
                        initialType="Préstamo"
                      />
                    </section>
                  )}

                  {almacenSection === 'devoluciones' && (
                    <section id="devoluciones" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <ReturnModule
                        assignments={assignments}
                        materials={materials}
                        people={people}
                        warehouses={warehouses}
                        onRegister={registerReturn}
                      />
                    </section>
                  )}

                  {almacenSection === 'salidas' && (
                    <section id="salidas" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <ExitModule
                        materials={materials}
                        brandItems={brandItems}
                        warehouses={warehouses}
                        onRegister={registerExit}
                      />
                    </section>
                  )}

                  {almacenSection === 'traslados' && (
                    <section id="traslados" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <TransferModule
                        materials={materials}
                        warehouses={warehouses}
                        onRegister={registerTransfer}
                      />
                    </section>
                  )}

                  {almacenSection === 'consumibles' && (
                    <section id="consumibles" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <ConsumiblesModule
                        materials={materials}
                        brandItems={brandItems}
                        warehouses={warehouses}
                        onRegister={registerExit}
                        people={people}
                      />
                    </section>
                  )}

                  {almacenSection === 'consumos-subbodega' && (
                    <section id="consumos-subbodega" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <SubWarehouseConsumptionModule
                        materials={materials}
                        warehouses={warehouses}
                        onRegister={registerExit}
                        people={people}
                      />
                    </section>
                  )}

                  {almacenSection === 'historial' && (
                    <section id="historial" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <MovementsModule refreshKey={movementsRefreshKey} />
                    </section>
                  )}

                  {almacenSection === 'indicadores' && (
                    <section id="indicadores" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <div className="mb-4">
                        <div className="flex items-center justify-center gap-3 mb-3 text-center">
                          {(() => (
                            <svg width="28" height="28" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <rect x="2" y="3" width="20" height="18" rx="4" fill="#F3F4F6" />
                              <rect x="5" y="10" width="3" height="8" rx="1" fill="#60A5FA" />
                              <rect x="10" y="6" width="3" height="12" rx="1" fill="#34D399" />
                              <rect x="15" y="8" width="3" height="10" rx="1" fill="#F59E0B" />
                              <circle cx="19" cy="5" r="1.5" fill="#A78BFA" />
                            </svg>
                          ))()}
                          <div className="text-2xl font-extrabold text-gray-900">Análisis de Inventario</div>
                        </div>
                        <div className="flex justify-center">
                          <div className="inline-flex items-center rounded-2xl border border-gray-300 shadow-sm bg-white overflow-hidden">
                            <button
                              type="button"
                              onClick={() => setIndMode('mas')}
                              className={`flex items-center gap-2 px-4 py-2 text-sm ${indMode==='mas' ? 'text-white bg-blue-600' : 'text-gray-800 bg-white'}`}
                            >
                              <span className="text-indigo-600 font-bold text-xs">TOP</span>
                              <svg width="10" height="10" viewBox="0 0 10 10" className="text-indigo-600" fill="currentColor"><path d="M5 1l3.5 6H1.5L5 1z"/></svg>
                              <span>Más Asignados</span>
                            </button>
                          <button
                            type="button"
                            onClick={() => setIndMode('menos')}
                            className={`flex items-center gap-2 px-4 py-2 text-sm ${indMode==='menos' ? 'text-white' : 'text-gray-800 bg-white'}`}
                            style={indMode==='menos' ? { backgroundColor: '#F07E2D' } : undefined}
                          >
                            <svg width="10" height="10" viewBox="0 0 10 10" className={`${indMode==='menos' ? 'text-white' : ''}`} fill="currentColor"><path d="M5 9L1.5 3h7L5 9z"/></svg>
                            <span>Menos Asignados</span>
                          </button>
                          <button
                            type="button"
                            onClick={() => setIndMode('prestados')}
                            className={`flex items-center gap-2 px-4 py-2 text-sm ${indMode==='prestados' ? 'text-white' : 'text-gray-800 bg-white'}`}
                            style={indMode==='prestados' ? { backgroundColor: '#8B5CF6' } : undefined}
                          >
                            <svg width="10" height="10" viewBox="0 0 10 10" className={`${indMode==='prestados' ? 'text-white' : ''}`} fill="currentColor"><circle cx="5" cy="5" r="3" /></svg>
                            <span>Elementos Prestados</span>
                          </button>
                          <button
                            type="button"
                            onClick={() => setIndMode('consumibles')}
                            className={`flex items-center gap-2 px-4 py-2 text-sm ${indMode==='consumibles' ? 'text-white' : 'text-gray-800 bg-white'}`}
                            style={indMode==='consumibles' ? { backgroundColor: '#06B6D4' } : undefined}
                          >
                            <svg width="10" height="10" viewBox="0 0 10 10" className={`${indMode==='consumibles' ? 'text-white' : ''}`} fill="currentColor"><path d="M5 0L9.5 9H0.5L5 0z"/></svg>
                            <span>Consumibles</span>
                          </button>
                          </div>
                        </div>
                      </div>
                      {(indMode === 'prestados' || indMode === 'consumibles') && (
                        <div className="mb-3">
                          <div className="text-sm text-gray-700 mb-1 text-center">Seleccionar Almacén:</div>
                          <div className="max-w-md mx-auto">
                            <select value={indWh || ''} onChange={(e)=>setIndWh(e.target.value)} className="w-full border rounded-md px-3 py-2">
                              {(warehouses||[]).map(w => (<option key={w.id} value={w.id}>{w.name}</option>))}
                            </select>
                          </div>
                        </div>
                      )}
                      {indMode !== 'prestados' && indMode !== 'consumibles' && (
                        <>
                          <div className="flex justify-center items-center gap-2 mb-3">
                            <button type="button" onClick={() => setIndTab('elemPorAlmacen')} className={`px-4 py-2 rounded-lg border ${indTab==='elemPorAlmacen' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300'}`}>Top 10 Elementos por Almacén</button>
                            <button type="button" onClick={() => setIndTab('almPorElemento')} className={`px-4 py-2 rounded-lg border ${indTab==='almPorElemento' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300'}`}>Top 10 Almacenes por Elemento</button>
                          </div>
                          <div className="mb-3">
                            <div className="text-sm text-gray-700 mb-1 text-center">{indTab==='elemPorAlmacen' ? 'Seleccionar Almacén:' : 'Seleccionar Elemento:'}</div>
                            <div className="max-w-md mx-auto">
                              {indTab==='elemPorAlmacen' ? (
                                <select value={indWh || ''} onChange={(e)=>setIndWh(e.target.value)} className="w-full border rounded-md px-3 py-2">
                                  {(warehouses||[]).map(w => (<option key={w.id} value={w.id}>{w.name}</option>))}
                                </select>
                              ) : (
                                <select value={String(indMat||'')} onChange={(e)=>setIndMat(parseInt(e.target.value))} className="w-full border rounded-md px-3 py-2">
                                  {(materials||[]).map(m => (<option key={m.id} value={m.id}>{m.name}</option>))}
                                </select>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      <div className="mb-4">
                        <div className="text-sm text-gray-700 mb-1 text-center">Rango de fechas</div>
                        <div className="flex justify-center gap-2">
                          <input type="date" value={fromDate} onChange={(e)=>setFromDate(e.target.value)} className="border rounded-md px-3 py-2" />
                          <input type="date" value={toDate} onChange={(e)=>setToDate(e.target.value)} className="border rounded-md px-3 py-2" />
                          <button type="button" className="px-3 py-2 rounded-md border border-gray-300" onClick={()=>{setFromDate(''); setToDate('');}}>Limpiar</button>
                          <button type="button" className="px-3 py-2 rounded-md border border-gray-300" onClick={()=>setSortDir(sortDir==='asc'?'desc':'asc')}>{sortDir==='asc'?'Orden: Asc':'Orden: Desc'}</button>
                        </div>
                      </div>
                      <div className="rounded-xl border border-gray-200 p-4 mb-4">
                        {chartItems.length ? (
                          <div className="w-full">
                            {(() => {
                              const W = 640; const H = 220; const L = 40; const R = 10; const T = 10; const B = 28;
                              const innerW = W - L - R; const innerH = H - T - B; const n = chartItems.length;
                              const barW = innerW / Math.max(n, 1) - 12;
                              const color = indMode==='mas' ? '#3B82F6' : indMode==='prestados' ? '#8B5CF6' : indMode==='consumibles' ? '#06B6D4' : '#F07E2D';
                              const ticks = [];
                              return (
                                <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-[200px]">
                                  <rect x={L} y={T} width={innerW} height={innerH} rx={8} fill="#fff" />
                                  {ticks.map((t,i)=>null)}
                                  {chartItems.map((it, idx)=>{
                                    const x = L + idx*(innerW/Math.max(n,1)) + 6;
                                    const h = maxValue>0 ? (it.value/maxValue)*innerH : 0;
                                    const y = T + innerH - h;
                                    return (
                                      <g key={idx}>
                                        <rect x={x} y={y} width={barW} height={h} fill={color} rx={4} />
                                        <text x={x + barW/2} y={Math.max(T + 10, y - 6)} textAnchor="middle" fontSize={11} fill="#111827" fontWeight="600">{it.value}</text>
                                        <text x={x + barW/2} y={H - 8} textAnchor="middle" fontSize={11} fill="#374151">{it.label}</text>
                                      </g>
                                    );
                                  })}
                                  
                                </svg>
                              );
                            })()}
                          </div>
                        ) : (
                          <div className="text-sm text-gray-500">Sin datos</div>
                        )}
                      </div>
                      <div className="rounded-xl border border-gray-200">
                        <div className={`px-4 py-2 text-base font-semibold text-center ${indMode==='mas' ? 'text-green-700' : ''}`} style={indMode==='menos' ? { color: '#F07E2D' } : indMode==='prestados' ? { color: '#8B5CF6' } : indMode==='consumibles' ? { color: '#06B6D4' } : undefined}>Detalle: {indMode==='mas' ? 'Más Asignados' : indMode==='prestados' ? 'Elementos Prestados' : indMode==='consumibles' ? 'Consumibles' : 'Menos Asignados'}</div>
                        <div className="overflow-auto">
                          <table className="min-w-full text-sm">
                            <thead>
                              <tr className="bg-gray-100">
                                <th className="px-4 py-2 text-left">Posición</th>
                                <th className="px-4 py-2 text-left">Código</th>
                                <th className="px-4 py-2 text-left">Nombre</th>
                                {indMode === 'prestados' && <th className="px-4 py-2 text-left">Responsable</th>}
                                {indMode === 'prestados' && <th className="px-4 py-2 text-left">Cédula</th>}
                                <th className="px-4 py-2 text-right">Cantidad</th>
                              </tr>
                            </thead>
                            <tbody>
                              {chartItems.map((it, idx) => (
                                <tr key={`r-${idx}`} className="border-t">
                                  <td className="px-4 py-2">#{idx+1}</td>
                                  <td className="px-4 py-2">{it.label}</td>
                                  <td className="px-4 py-2">{it.name || '—'}</td>
                                  {indMode === 'prestados' && <td className="px-4 py-2">{it.responsibleName || '—'}</td>}
                                  {indMode === 'prestados' && <td className="px-4 py-2">{it.responsibleDoc || '—'}</td>}
                                  <td className="px-4 py-2 text-right font-semibold">{it.value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  )}

                  {almacenSection === 'consumo-centro-costo' && (
                    <section id="consumo-centro-costo" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <CostCenterReportModule />
                    </section>
                  )}

                  {almacenSection === 'alertas' && (
                    <section id="alertas" className="bg-white rounded-xl shadow border border-gray-200 p-5">
                      <div className="rounded-2xl p-5 mb-5" style={{ background: 'linear-gradient(135deg, #9CA3AF 0%, #D1D5DB 40%, #F3F4F6 100%)' }}>
                        <div className="text-white text-2xl font-bold mb-4">Panel de Alertas</div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                          <div className="bg-white rounded-xl shadow-md p-4 flex items-center justify-between">
                            <div>
                              <div className="text-xs uppercase tracking-wide text-gray-600">Total de Alertas</div>
                              <div className="text-3xl font-bold">{alerts.loading ? '…' : alerts.total}</div>
                            </div>
                            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                              <Bell size={20} className="text-gray-600" />
                            </div>
                          </div>
                          <div className="bg-white rounded-xl shadow-md p-4 flex items-center justify-between">
                            <div>
                              <div className="text-xs uppercase tracking-wide text-gray-600">Stock Bajo</div>
                              <div className="text-3xl font-bold" style={{ color: '#F07E2D' }}>{alerts.loading ? '…' : alerts.lowStock}</div>
                            </div>
                            <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center">
                              <Package size={20} className="text-rose-600" />
                            </div>
                          </div>
                          <div className="rounded-xl shadow-md p-4 flex items-center justify-between border" style={{ backgroundColor: '#FEE2E2', borderColor: '#FCA5A5' }}>
                            <div>
                              <div className="text-xs uppercase tracking-wide text-gray-600">Por Vencer</div>
                              <div className="text-3xl font-bold" style={{ color: '#DC2626' }}>{alerts.loading ? '…' : alerts.expiring}</div>
                            </div>
                            <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center">
                              <AlarmClock size={20} className="text-rose-600" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="rounded-2xl bg-white shadow-sm border border-gray-200 p-5">
                        <div className="flex items-center gap-2 text-base font-semibold mb-3">
                          <ClipboardList size={18} className="text-gray-700" />
                          <span>Índice de Alertas</span>
                        </div>
                        <div className="space-y-3">
                          <button
                            type="button"
                            onClick={() => setAlertsOpen(alertsOpen === 'low' ? null : 'low')}
                            className="w-full flex items-center justify-between rounded-xl px-4 py-3 bg-gray-100 hover:bg-gray-200"
                          >
                            <span className="flex items-center gap-2 text-gray-900">
                              <Package size={18} className="text-orange-500" />
                              <span className="font-semibold">Alertas de Stock Mínimo</span>
                            </span>
                            <span className="inline-flex items-center justify-center text-sm font-semibold bg-white rounded-full shadow px-3 h-7">{alerts.lowStock}</span>
                          </button>
                          <button
                            type="button"
                            onClick={() => setAlertsOpen(alertsOpen === 'exp' ? null : 'exp')}
                            className="w-full flex items-center justify-between rounded-xl px-4 py-3 bg-gray-100 hover:bg-gray-200"
                          >
                            <span className="flex items-center gap-2 text-gray-900">
                              <Calendar size={18} className="text-red-500" />
                              <span className="font-semibold">Alertas de Vencimiento</span>
                            </span>
                            <span className="inline-flex items-center justify-center text-sm font-semibold bg-white rounded-full shadow px-3 h-7">{alerts.expiring}</span>
                          </button>
                        </div>

                        {(!alerts.loading && alerts.total === 0) && (
                          <div className="flex flex-col items-center justify-center mt-6">
                            <div className="w-14 h-14 rounded-xl bg-green-100 flex items-center justify-center mb-2">
                              <CheckCircle size={28} className="text-green-500" />
                            </div>
                            <div className="text-sm text-gray-600">¡Todo en orden! No hay alertas pendientes.</div>
                          </div>
                        )}
                      </div>
                      {alertsOpen === 'low' && (
                        <div id="min-stock" className="mt-4">
                          {Array.isArray(alerts.lowStockItems) && alerts.lowStockItems.length > 0 ? (
                            <div className="space-y-3">
                              {alerts.lowStockItems.map((it, idx) => {
                                const deficit = Math.max(0, (parseInt(it.stockMin)||0) - (parseInt(it.stockActual)||0));
                                const pct = (() => {
                                  const min = parseInt(it.stockMin)||0; const act = parseInt(it.stockActual)||0; if (!min) return 0; return Math.round((act/min)*100);
                                })();
                                return (
                                  <div key={`ls-${it.id ?? idx}`} className="rounded-xl border border-orange-200 bg-orange-50 shadow-sm">
                                    <div className="flex items-start justify-between p-3">
                                      <div>
                                        <div className="text-base font-semibold text-gray-900">{it.name}</div>
                                      </div>
                                      <span className="text-xs px-2 py-1 rounded-full" style={{ backgroundColor: '#FDE68A', color: '#92400E' }}>{pct}% del mínimo</span>
                                    </div>
                                    <div className="grid grid-cols-2 gap-3 px-3 pb-3 text-sm">
                                      <div>
                                        <div className="text-gray-600">Stock Actual:</div>
                                        <div className="font-semibold" style={{ color: '#B45309' }}>{it.stockActual} {it.unitLabel}</div>
                                      </div>
                                      <div>
                                        <div className="text-gray-600">Stock Mínimo:</div>
                                        <div className="font-semibold" style={{ color: '#6B7280' }}>{it.stockMin} {it.unitLabel}</div>
                                      </div>
                                      <div>
                                        <div className="text-gray-600">Déficit:</div>
                                        <div className="font-semibold" style={{ color: '#DC2626' }}>{deficit} {it.unitLabel}</div>
                                      </div>
                                      <div>
                                        <div className="text-gray-600">Categoría:</div>
                                        <div className="font-semibold" style={{ color: '#374151' }}>{it.category || '—'}</div>
                                      </div>
                                    </div>
                                    <div className="px-3 pb-3 flex items-center justify-between gap-2 flex-wrap">
                                      <div className="text-xs rounded-md border p-2 flex-1 min-w-[220px]" style={{ borderColor: '#F59E0B', backgroundColor: '#FEF3C7', color: '#92400E' }}>
                                        Acción requerida: Solicitar compra de {deficit} {it.unitLabel}
                                      </div>
                                      <button
                                        type="button"
                                        onClick={() => requestPurchaseForLowStock(it)}
                                        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-white text-sm shadow-sm shrink-0"
                                        style={{ background: 'linear-gradient(90deg, #2563EB 0%, #4F46E5 100%)' }}
                                      >
                                        <ShoppingCart size={14} /> Solicitar compra
                                      </button>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="text-xs text-gray-500">Sin alertas de stock.</div>
                          )}
                        </div>
                      )}
                      {alertsOpen === 'exp' && (
                        <div id="expiring" className="mt-4">
                          {Array.isArray(alerts.expiringItems) && alerts.expiringItems.length > 0 ? (
                            <div className="space-y-2">
                              {alerts.expiringItems.map((it, idx) => {
                                const d = new Date(it.expireAt);
                                const now = new Date();
                                const diffDays = Math.ceil((d.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
                                const expired = isNaN(d) ? false : diffDays < 0;
                                const dateLabel = (() => { if (isNaN(d)) return it.expireAt || ''; return d.toLocaleDateString('es-CO'); })();
                                const daysText = isNaN(d) ? '' : (expired ? `Vencido hace ${Math.abs(diffDays)} días` : (diffDays === 0 ? 'Vence hoy' : `Vence en ${diffDays} días`));
                                return (
                                  <div key={`ex-${it.id ?? idx}`} className="rounded-lg border bg-red-50 shadow-sm" style={{ borderColor: '#FECACA' }}>
                                    <div className="flex items-start justify-between p-2">
                                      <div className="min-w-0">
                                        <div className="text-sm font-semibold text-gray-900">{it.materialName || 'Ítem'}</div>
                                        <div className="text-xs text-gray-700 truncate">Código: {it.materialCode || '—'}</div>
                                      </div>
                                      <div className="flex items-center gap-2">
                                        <div className="text-sm font-semibold text-gray-900">{it.serial || '—'}</div>
                                        <span className="text-xs px-2 py-1 rounded-full" style={{ backgroundColor: '#FECACA', color: '#9B1C1C' }}>{expired ? 'VENCIDO' : 'PRÓXIMO'}</span>
                                      </div>
                                    </div>
                                    <div className="grid grid-cols-2 gap-2 px-2 pb-2 text-xs">
                                      <div>
                                        <div className="text-gray-600">Fecha de Vencimiento:</div>
                                        <div className="font-semibold" style={{ color: '#DC2626' }}>{dateLabel}</div>
                                      </div>
                                      <div>
                                        <div className="text-gray-600">Días Restantes:</div>
                                        <div className="font-semibold" style={{ color: '#DC2626' }}>{daysText}</div>
                                      </div>
                                      <div>
                                        <div className="text-gray-600">Stock Actual:</div>
                                        <div className="font-semibold" style={{ color: '#374151' }}>{it.stockActual} {it.unitLabel}</div>
                                      </div>
                                      <div>
                                        <div className="text-gray-600">Categoría:</div>
                                        <div className="font-semibold" style={{ color: '#374151' }}>{it.category || '—'}</div>
                                      </div>
                                    </div>
                                    <div className="px-2 pb-2">
                                      <div className="text-xs rounded-md border p-1" style={{ borderColor: '#FCA5A5', backgroundColor: '#FEE2E2', color: '#9B1C1C' }}>
                                        {expired ? 'Producto VENCIDO - Retirar del almacén inmediatamente' : 'Producto próximo a vencerse - Priorizar su salida'}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="text-xs text-gray-500">Sin alertas de vencimiento.</div>
                          )}
                        </div>
                      )}
                    </section>
                  )}

                  <Modal isOpen={whOpen} onClose={() => { setWhOpen(false); setWhErr(''); }} title="Configurar Bodegas" size="max-w-xl">
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const name = String(newWhName).trim();
                        const code = String(newWhCode).trim();
                        if (!name) { setWhErr('El nombre es obligatorio'); return; }
                        const exists = (warehouses || []).some((w) => String(w.name).trim().toLowerCase() === name.toLowerCase() || String(w.id).trim().toLowerCase() === code.toLowerCase());
                        if (exists) { setWhErr('La bodega ya existe'); return; }
                        await addWarehouse({ name, id: code, parent_id: newWhParentId || null, consecutivo_prefix: newWhParentId ? (newWhPrefix || null) : null });
                        setNewWhName('');
                        setNewWhCode('');
                        setNewWhParentId('');
                        setNewWhPrefix('');
                        setWhErr('');
                        setWhOpen(false);
                      }}
                      className="grid grid-cols-2 gap-4"
                    >
                      {whErr && (
                        <div className="col-span-2 text-red-600 text-sm mb-2">{whErr}</div>
                      )}
                      <div className="col-span-2">
                        <label className="block text-sm font-medium mb-1">Nombre de bodega *</label>
                        <input
                          type="text"
                          value={newWhName}
                          onChange={(e) => setNewWhName(e.target.value)}
                          className="w-full border rounded px-3 py-2"
                          required
                        />
                      </div>
                      <div className="col-span-2">
                        <label className="block text-sm font-medium mb-1">Código/ID (opcional)</label>
                        <input
                          type="text"
                          value={newWhCode}
                          onChange={(e) => setNewWhCode(e.target.value)}
                          className="w-full border rounded px-3 py-2"
                          placeholder="Ej: popayan, santander, lv-centro"
                        />
                      </div>
                      <div className="col-span-2">
                        <label className="block text-sm font-medium mb-1">Bodega padre (opcional)</label>
                        <select
                          value={newWhParentId}
                          onChange={(e) => setNewWhParentId(e.target.value)}
                          className="w-full border rounded px-3 py-2"
                        >
                          <option value="">— Ninguna (bodega de primer nivel) —</option>
                          {(warehouses || []).filter((w) => !w.parent_id).map((w) => (
                            <option key={w.id} value={w.id}>{w.name}</option>
                          ))}
                        </select>
                        <div className="text-xs text-gray-500 mt-1">Elige una bodega padre para crear esta como sub-bodega (ej. sub-bodegas de Línea viva centro).</div>
                      </div>
                      {newWhParentId && (
                        <div className="col-span-2">
                          <label className="block text-sm font-medium mb-1">Prefijo consecutivo (opcional)</label>
                          <input
                            type="text"
                            value={newWhPrefix}
                            onChange={(e) => setNewWhPrefix(e.target.value.toUpperCase())}
                            className="w-full border rounded px-3 py-2"
                            placeholder="Ej: LV (si se deja vacío se usa el ID de la bodega padre)"
                          />
                        </div>
                      )}
                      <div className="col-span-2">
                        <div className="text-sm text-gray-700 mb-1">Bodegas actuales</div>
                        <div className="border rounded overflow-hidden">
                          <table className="min-w-full text-sm">
                            <thead>
                              <tr className="bg-gray-100 text-gray-700">
                                <th className="px-3 py-2 text-left">ID</th>
                                <th className="px-3 py-2 text-left">Nombre</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(warehouses || []).map((w) => {
                                const parentWh = w.parent_id ? (warehouses || []).find((p) => String(p.id) === String(w.parent_id)) : null;
                                return (
                                <tr key={w.id} className="border-t">
                                  <td className="px-3 py-2">{w.id}</td>
                                  <td className="px-3 py-2">
                                    {editingWhId === String(w.id) ? (
                                      <input
                                        type="text"
                                        value={editingWhName}
                                        onChange={(e) => setEditingWhName(e.target.value)}
                                        className="w-full border rounded px-2 py-1"
                                      />
                                    ) : (
                                      <>
                                        {w.name}
                                        {parentWh && (
                                          <div className="text-xs text-gray-500">↳ bajo {parentWh.name}</div>
                                        )}
                                      </>
                                    )}
                                  </td>
                                  <td className="px-3 py-2 text-right">
                                    {editingWhId === String(w.id) ? (
                                      <>
                                        <button
                                          type="button"
                                          className="bg-blue-500 text-white px-3 py-1 rounded mr-2"
                                          onClick={async () => {
                                            const nm = String(editingWhName).trim();
                                            if (!nm) { setWhErr('Nombre requerido'); return; }
                                            await updateWarehouse({ id: w.id, name: nm, parent_id: w.parent_id || null, consecutivo_prefix: w.consecutivo_prefix || null });
                                            setEditingWhId('');
                                            setEditingWhName('');
                                            setWhErr('');
                                          }}
                                        >
                                          Guardar
                                        </button>
                                        <button
                                          type="button"
                                          className="bg-gray-300 px-3 py-1 rounded"
                                          onClick={() => { setEditingWhId(''); setEditingWhName(''); setWhErr(''); }}
                                        >
                                          Cancelar
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          type="button"
                                          className="bg-gray-800 text-white px-3 py-1 rounded mr-2"
                                          onClick={() => { setEditingWhId(String(w.id)); setEditingWhName(w.name || ''); }}
                                        >
                                          Editar
                                        </button>
                                        <button
                                          type="button"
                                          className="bg-red-600 text-white px-3 py-1 rounded"
                                          onClick={async () => { await deleteWarehouse(w.id); }}
                                        >
                                          Eliminar
                                        </button>
                                      </>
                                    )}
                                  </td>
                                </tr>
                              );})}
                              {(!warehouses || warehouses.length === 0) && (
                                <tr>
                                  <td className="px-3 py-3 text-center text-gray-500" colSpan={2}>Sin bodegas</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-span-2 flex gap-2 mt-2">
                        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">Guardar</button>
                        <button type="button" onClick={() => { setWhOpen(false); setWhErr(''); }} className="bg-gray-300 px-4 py-2 rounded">Cancelar</button>
                      </div>
                    </form>
                  </Modal>
                </div>
              </div>
            )}
            {selected === 'sig' && isAllowedModule('sig') && (
              <SGIPanel
                location={location}
                showLocation={false}
                people={people}
                materials={materials}
                assignments={assignments}
                warehouses={warehouses}
              />
            )}
            {selected === 'contabilidad' && isAllowed('contabilidad') && (
              <ContabilidadPanel
                location={location}
                showLocation={false}
                prefillPurchaseRequest={prefillPurchaseRequest}
                onPrefillConsumed={() => setPrefillPurchaseRequest(null)}
              />
            )}
            {selected === 'transportes' && isAllowed('transportes') && (
              <TransportesPanel location={location} showLocation={false} />
            )}
            {selected === 'seguridad' && isAllowed('seguridad') && (
              <SeguridadPanel location={location} showLocation={false} />
            )}
            {selected === 'control-operativo' && isAllowed('control-operativo') && (
              <ControlOperativoPanel location={location} showLocation={false} />
            )}
            {selected === 'administracion-ti' && isAllowed('administracion-ti') && (
              <AdministracionTIPanel location={location} showLocation={false} />
            )}
              </div>
            </>
          )}
        </div>

        {/* Eliminado: vista de selecciÃƒÂ³n de sede */}
      </div>

      <Modal
        isOpen={!!currentUser && showBirthdayModal}
        onClose={() => setShowBirthdayModal(false)}
        title={null}
        size="w-[95%] max-w-[500px] p-0 max-h-[600px]"
        fullWidth={false}
        panelClassName="bg-transparent p-0"
      >
        <BirthdayWidget people={people} compact onClose={() => setShowBirthdayModal(false)} />
      </Modal>

      {/* Botón flotante de chat en línea (esquina inferior izquierda).
          Antes iba abajo a la derecha y en z-50, igual que los modales, así
          que quedaba encima de ellos tapando el botón "Guardar" (alineado a
          la derecha). En z-40 los formularios abiertos lo cubren. */}
      <button
        type="button"
        aria-label="Abrir Mesa de Ayuda"
        className="fixed bottom-4 left-4 z-40 p-0 bg-transparent"
        onClick={() => {
          setHelpDeskOpen(true);
        }}
      >
        <img
          src={senerfitoWsp}
          alt="Chat en línea Senerfito"
          className="h-[2cm] w-[2cm] p-[1mm]"
        />
      </button>

      <HelpDeskModal
        isOpen={helpDeskOpen}
        onClose={() => setHelpDeskOpen(false)}
        avatarSrc={soporteSenerfitoGif}
        values={helpDeskForm}
        submitting={helpDeskSubmitting}
        onChange={(patch) => setHelpDeskForm((p) => ({ ...p, ...patch }))}
        onReset={() => setHelpDeskForm({ name: currentUser?.name || '', email: currentUser?.email || '', dni: '', subject: '', category: '', department: '', description: '', priority: 'Media' })}
        onSubmit={submitHelpDesk}
      />

      {/* Pie de página */}
      <div className="w-full text-center text-sm mt-2 mb-4" style={{ color: '#776F74' }}>
        <span>© 2026 Senerfi SAS</span><br />
        <span>Soluciones que Generan Desarrollo</span>
      </div>
    </div>
  );
}

